// LIBRARIES
import styled, { css } from "styled-components";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

// MISC
import { COLORS } from "constants/styleVariables";

export const FiltersComponentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
 `;
 export const FiltersIcon = styled(FilterAltOffIcon)`
  margin-right: 50px;
 `;
export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RightContentContainer = styled.div``;
